<rdx-main-header />
<div #contentContainer class="site-content-container">
  <router-outlet />
</div>
